import { createPortal } from "react-dom";
import React, { useEffect, useRef, useState, useCallback } from "react";
import { ReceiptPrintPage } from "components/BillPaper";

export default function ReportBillDetailPrintPopup({
  isOpen,
  isCopy,
  onPrintComplete,
  billData,
  orderBill,
  currentPOS,
}) {
  const componentRef = useRef();
  const [isDataReady, setIsDataReady] = useState(false);

  // Reset ready state whenever popup opens/closes
  useEffect(() => {
    if (!isOpen) {
      setIsDataReady(false);
    }
  }, [isOpen]);

  const handleDataLoaded = useCallback(() => {
    setIsDataReady(true);
  }, []);

  useEffect(() => {
    if (isOpen && isDataReady) {
      // Add print-specific styles when data is ready
      const style = document.createElement("style");
      style.id = "print-style-popup";
      style.innerHTML = `
        @media print {
          body * {
            visibility: hidden;
          }
          .section-to-print-receipt-page,
          .section-to-print-receipt-page * {
            visibility: visible;
          }
          .section-to-print-receipt-page {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            display: flex;
            justify-content: center;
          }
          @page {
            size: 80mm auto;
            margin: 0mm;
          }
        }
      `;
      document.head.appendChild(style);

      // Short delay to ensure DOM has painted after data load
      const printTimer = setTimeout(() => {
        window.print();

        if (onPrintComplete) {
          setTimeout(() => {
            onPrintComplete();
          }, 500);
        }
      }, 300);

      return () => {
        clearTimeout(printTimer);
        const styleElement = document.getElementById("print-style-popup");
        if (styleElement) {
          styleElement.remove();
        }
      };
    }
  }, [isOpen, isDataReady, onPrintComplete]);

  if (!isOpen || !billData) return null;

  return createPortal(
    <div className="section-to-print-receipt-page print:block hidden">
      <ReceiptPrintPage
        ref={componentRef}
        order={billData}
        bill={orderBill}
        pos={currentPOS}
        type="receipt"
        copy={isCopy}
        onDataLoaded={handleDataLoaded}
      />
    </div>,
    document.body
  );
}
